import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const aievaluationPlugin = createPlugin({
  id: 'aievaluation',
  routes: {
    root: rootRouteRef,
  },
});

export const AievaluationPage = aievaluationPlugin.provide(
  createRoutableExtension({
    name: 'AievaluationPage',
    component: () => import('./App').then(m => m.App),
    mountPoint: rootRouteRef,
  }),
);
